import { Component, ChangeDetectionStrategy, input, output, computed } from '@angular/core';
import { AbstractComponent } from '@spike/scaffolds';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IsinValue } from '../../models/isin-value.model';
@Component({
  selector: 'spike-isin-value-list',
  templateUrl: './isin-value-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class IsinValueListComponent extends AbstractComponent {
  list = input.required<IsinValue[]>();
  onSelect = output<IsinValue>();

  sortedList = computed(() => {
    return [...this.list()].sort((a, b) => {
      const dateA = new Date(a.priceDate).getTime();
      const dateB = new Date(b.priceDate).getTime();
      
      return dateB - dateA;
    });
  });

}
